import { BWMModelBase } from './bwm-zones-model';
import { ZoneFeature } from './zones-base-interfaces';
import { BWMjson } from '../models/test/bwm-zones-geojson'

export class BWMModelImpl extends BWMModelBase {
    async getBWMZones(): Promise<ZoneFeature[] | null> {
        this.fetchZones();

        const bwmZones = this._zones;
        return bwmZones;
    }

    constructor(geojson?: ZoneFeature[]) {
        super();
        if (geojson) {
            this._zones = geojson;
        } else {
            // setInterval(() => this.fetchZones(), 60*60*1000); // add line back in when API is in place if needed, if not then remove this line
        }
    }

    private _zones: ZoneFeature[] | null = null;


    private fetchZones() {
        // replace the API call to fetch zones
        const zones : ZoneFeature[] = BWMjson
        if (zones) {
            this._zones = zones;
        }
    }
}